import { Checkbox } from '@mui/material';

import ArgonTypography from 'component/Argon/ArgonTypography';

export default function InputAgreement({ agreement, setAgremment }) {
  return (
    <>
      <Checkbox checked={agreement} onChange={setAgremment} />
      <ArgonTypography
        variant="button"
        fontWeight="regular"
        onClick={setAgremment}
        sx={{ cursor: 'pointer', userSelect: 'none' }}
      >
        ฉันยอมรับ&nbsp;เงื่อนไขการบริการ&nbsp;
      </ArgonTypography>
      <ArgonTypography
        onClick={setAgremment}
        variant="button"
        fontWeight="bold"
        textGradient
      >
        TKR-BROKER
      </ArgonTypography>
    </>
  );
}
